import {WebToAppCtaImageRequestParams} from "./web-to-app-cta.image.request-params";

export class WebToAppCtaLogoImageRequestParams extends WebToAppCtaImageRequestParams {
  constructor(width: Number,height: Number) {
    super(width, height);

    this.resourceName = `${this.resourceName}/appLogo.svg`;
  }
}
